import { getTodayString } from "@/libraries/date";
import { createStore } from "zustand";
import { persist } from "zustand/middleware";
import { shallow } from "zustand/shallow";
import { useStoreWithEqualityFn } from "zustand/traditional";

interface DownloadStoreState {
	lastShownPopup: ReturnType<typeof getTodayString> | null;
	isPopupOpen: boolean;
}

interface DownloadStoreActions {
	shouldShowPopup: () => boolean;
	showPopup: () => void;
	markAsShown: () => void;
}

type DownloadStore = DownloadStoreState & DownloadStoreActions;

export const useDownloadStore = createStore<DownloadStore>()(
	persist(
		(set, get) => ({
			lastShownPopup: null,
			isPopupOpen: false,
			shouldShowPopup: () => {
				const { lastShownPopup } = get();
				const today = getTodayString();
				return lastShownPopup !== today;
			},

			showPopup: () => {
				const { shouldShowPopup } = get();
				if (shouldShowPopup()) {
					set({ isPopupOpen: true });
				}
			},

			markAsShown: () => {
				const today = getTodayString();
				set({
					lastShownPopup: today,
					isPopupOpen: false,
				});
			},
		}),
		{
			name: "downlod-mobile",
			partialize: (state) => ({
				lastShownPopup: state.lastShownPopup,
			}),
		},
	),
);

export function useDownloadShallow<T>(
	selector: (store: DownloadStore) => T,
): T {
	return useStoreWithEqualityFn(useDownloadStore, selector, shallow);
}
